module.exports = __webpack_public_path__ + "img/img13.be0e5467.png";